import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';
import { v4 } from 'uuid';

import { userApiRequests } from './api-requests/user';

export const encodeData = (data: unknown): string => {
    return compressToEncodedURIComponent(JSON.stringify(data));
};

export const decodeData = <T = unknown>(encoded: string): T | null => {
    try {
        const json = decompressFromEncodedURIComponent(encoded);

        return json ? JSON.parse(json) : null;
    } catch (err) {
        const errorId = v4();
        userApiRequests.logException(err as Error, errorId, {
            functionName: 'decodeData from utils'
        });

        return null;
    }
};
